import actions from "./actions";
import {setErrorReducer, setRequestReducer, setSuccessReducer} from "../helper";
// import {getShopeePayoutSummary} from "./utils/getShopeePayoutSummary";

const initState = {
    extensions: [],
    getExtensionListState: null,

    // MPS Extension
    mpsReadOptionListState: null,
    mpsUpdateOptionListState: null,
    mpsSynchroniseState: null,
    mpsLog: null,
    mpsOptions: {
        client_id: null,
        client_secret: null,
        username: null,
        password: null,
        dealer_code: null,
        frequency: null,
        report_emails: null,
        sync_start_date: null,
        last_sync_at: null,
        create_as: null,
        send_invoice_email: null,
        account_mappings: {},
        tax_code_mappings: {},
    },
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.EXTENSION_GET_EXTENSION_LIST_REQUEST:
            return setRequestReducer(state, 'getExtensionListState');
        case actions.EXTENSION_GET_EXTENSION_LIST_SUCCESS:
            return setSuccessReducer(state, 'getExtensionListState', {
                extensions: action.extensions,
            });

        // MPS Extension
        case actions.EXTENSION_MPS_READ_OPTION_LIST_REQUEST:
            return setRequestReducer(state, 'mpsReadOptionListState');
        case actions.EXTENSION_MPS_READ_OPTION_LIST_SUCCESS:
            return setSuccessReducer(state, 'mpsReadOptionListState', {
                mpsOptions: action.options,
            });
        case actions.EXTENSION_MPS_READ_OPTION_LIST_ERROR:
            return setErrorReducer(state, 'mpsReadOptionListState');
        case actions.EXTENSION_MPS_UPDATE_OPTION_LIST_REQUEST:
            return setRequestReducer(state, 'mpsUpdateOptionListState');
        case actions.EXTENSION_MPS_UPDATE_OPTION_LIST_SUCCESS:
            return setSuccessReducer(state, 'mpsUpdateOptionListState');
        case actions.EXTENSION_MPS_UPDATE_OPTION_LIST_ERROR:
            return setErrorReducer(state, 'mpsUpdateOptionListState');
        case actions.EXTENSION_MPS_SYNCHRONISE_REQUEST:
            return setRequestReducer(state, 'mpsSynchroniseState');
        case actions.EXTENSION_MPS_SYNCHRONISE_SUCCESS:
            return setSuccessReducer(state, 'mpsSynchroniseState', {
                mpsLog: action.log,
            });
        case actions.EXTENSION_MPS_SYNCHRONISE_ERROR:
            return setErrorReducer(state, 'mpsSynchroniseState');

        case actions.EXTENSION_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
